import { actionGenerator } from "utils";
import {
  VALIDATE_CODE,
  REQUEST_OTP,
  VERIFY_OTP,
  OTP_LOG,
  REQUEST_LOGIN,
  UPDATE_USER_INFO,
  REQUEST_GIGYA,
  EXCHANGE_CODE,
  TOPUP_MOBILE,
  VALIDATE_CAMPAIGN,
  GET_STORE_BY_PHONE,
  GET_CAMPAIGN_INFO,
  SUBMIT_WISH,
  GET_GIFT_SUMMARY,
  TAKE_GIFT,
  GET_BLOCK_LIST,
} from "./constants";

const actions = {
  VALIDATE_CODE: actionGenerator.genActions(VALIDATE_CODE),
  VALIDATE_CAMPAIGN: actionGenerator.genActions(VALIDATE_CAMPAIGN),
  REQUEST_OTP: actionGenerator.genActions(REQUEST_OTP),
  OTP_LOG: actionGenerator.genActions(OTP_LOG),
  VERIFY_OTP: actionGenerator.genActions(VERIFY_OTP),
  REQUEST_LOGIN: actionGenerator.genActions(REQUEST_LOGIN),
  UPDATE_USER_INFO: actionGenerator.genActions(UPDATE_USER_INFO),
  REQUEST_GIGYA: actionGenerator.genActions(REQUEST_GIGYA),
  EXCHANGE_CODE: actionGenerator.genActions(EXCHANGE_CODE),
  TOPUP_MOBILE: actionGenerator.genActions(TOPUP_MOBILE),
  //new
  GET_STORE_BY_PHONE: actionGenerator.genActions(GET_STORE_BY_PHONE),
  GET_CAMPAIGN_INFO: actionGenerator.genActions(GET_CAMPAIGN_INFO),
  SUBMIT_WISH: actionGenerator.genActions(SUBMIT_WISH),
  GET_GIFT_SUMMARY: actionGenerator.genActions(GET_GIFT_SUMMARY),
  TAKE_GIFT: actionGenerator.genActions(TAKE_GIFT),
  GET_BLOCK_LIST: actionGenerator.genActions(GET_BLOCK_LIST),

};

export default actions;
